import { AllessehContentQueryBody } from 'hooks/useAllessehContentQuery';
import * as BUSINESS from './sections/business';
import * as ECONOMY from './sections/economy';
import * as JAPAN from './sections/japan';
import * as LIFE from './sections/life';
import * as MARKETS from './sections/markets';
import * as OPINION from './sections/opinion';
import { DEFAULT_PRODUCT_VALUE } from './sections/shared/configs';
import * as TECHNOLOGY from './sections/tech';
import * as WORLD from './sections/world';
import { DEFAULT_QUERY } from '../default';

export type QueryOptionJwsj = {
  query: AllessehContentQueryBody;
  label: string;
  type:
    | BUSINESS.SECTION_ENUM
    | LIFE.SECTION_ENUM
    | MARKETS.SECTION_ENUM
    | OPINION.SECTION_ENUM
    | TECHNOLOGY.SECTION_ENUM
    | WORLD.SECTION_ENUM
    | ECONOMY.SECTION_ENUM
    | null;
  url: string | null;
};

type QueryOptions = {
  [key: string]: QueryOptionJwsj[];
};

type QueryConfig = {
  [key: string]: QueryOptions;
};

export const QUERY_CONFIG_JWSJ: QueryConfig = {
  business: {
    SECTION_TOP: [{ query: BUSINESS.MAIN, label: 'Lead Story', type: null, url: null }],
    SECTION_TOP_SIX_STORIES: [{ query: BUSINESS.MAIN, label: 'Top Stories', type: null, url: null }],
    LEADING_AND_SUPPORT: [
      {
        query: BUSINESS.AUTOS_QUERY,
        label: '自動車',
        url: 'news/types/j-autos',
        type: BUSINESS.SECTION_ENUM.AUTOS
      },
      {
        query: BUSINESS.CAREERS_QUERY,
        label: 'キャリア',
        url: 'news/types/j-careers',
        type: BUSINESS.SECTION_ENUM.CAREERS
      },
      {
        query: BUSINESS.ENERGY_QUERY,
        label: 'エネルギー',
        url: 'news/types/j-energy',
        type: BUSINESS.SECTION_ENUM.ENERGY
      },
      {
        query: BUSINESS.HEALTHCARE_QUERY,
        label: 'ヘルスケア',
        url: 'news/types/j-healthcare',
        type: BUSINESS.SECTION_ENUM.HEALTHCARE
      }
    ],
    MORE_LIST: [{ query: BUSINESS.MAIN, label: 'その他のビジネス記事', type: null, url: null }]
  },
  economy: {
    SECTION_TOP: [{ query: ECONOMY.MAIN, label: 'Lead Story', type: null, url: null }],
    SECTION_TOP_SIX_STORIES: [{ query: ECONOMY.MAIN, label: 'Top Stories', type: null, url: null }],
    LEADING_AND_SUPPORT: [
      {
        query: ECONOMY.CAPITAL_ACCOUNT_QUERY,
        label: 'Capital Account',
        url: 'news/types/j-capital-account',
        type: ECONOMY.SECTION_ENUM.CAPITAL_ACCOUNT
      },
      {
        query: ECONOMY.STREETWISE_QUERY,
        label: 'Streetwise',
        url: 'news/types/j-streetwise',
        type: ECONOMY.SECTION_ENUM.STREETWISE
      },
      {
        query: ECONOMY.HEARD_QUERY,
        label: 'Heard on the Street',
        url: 'news/types/j-heard',
        type: ECONOMY.SECTION_ENUM.HEARD_STREET
      },
      {
        query: ECONOMY.MONETARY_POLICY_QUERY,
        label: '金融政策ウオッチ',
        url: 'news/types/j-monetary-policy',
        type: ECONOMY.SECTION_ENUM.MONETARY_POLICY
      }
    ],
    MORE_LIST: [{ query: ECONOMY.MAIN, label: 'その他の経済記事', type: null, url: null }]
  },
  markets: {
    SECTION_TOP: [{ query: MARKETS.MAIN, label: 'Lead Story', type: null, url: null }],
    SECTION_TOP_SIX_STORIES: [{ query: MARKETS.MAIN, label: 'Top Stories', type: null, url: null }],
    LEADING_AND_SUPPORT: [
      {
        query: MARKETS.HEARD_QUERY,
        label: 'Heard on the Street',
        url: 'news/types/j-heard',
        type: MARKETS.SECTION_ENUM.HEARD_ON_THE_STREET
      },
      {
        query: MARKETS.STREETWISE_QUERY,
        label: 'Streetwise',
        url: 'news/types/j-streetwise',
        type: MARKETS.SECTION_ENUM.STREETWISE
      },
      {
        query: MARKETS.THE_INTELLIGENT_INVESTOR_QUERY,
        label: 'The Intelligent Investor',
        url: 'news/types/j-the-intelligent-investor',
        type: MARKETS.SECTION_ENUM.THE_INTELLIGENT_INVESTOR
      },
      {
        query: MARKETS.CAPITAL_ACCOUNT_QUERY,
        label: 'Capital Account',
        url: 'news/types/j-capital-account',
        type: MARKETS.SECTION_ENUM.CAPITAL_ACCOUNT
      }
    ],
    MORE_LIST: [{ query: MARKETS.MAIN, label: 'その他のマーケット記事', type: null, url: null }]
  },
  japan: {
    SECTION_TOP: [{ query: JAPAN.MAIN, label: 'Lead Story', type: null, url: null }],
    SECTION_TOP_SIX_STORIES: [{ query: JAPAN.MAIN, label: 'Top Stories', type: null, url: null }]
  },
  life: {
    SECTION_TOP: [{ query: LIFE.MAIN, label: 'Lead Story', type: null, url: null }],
    SECTION_TOP_SIX_STORIES: [{ query: LIFE.MAIN, label: 'Top Stories', type: null, url: null }],
    LEADING_AND_SUPPORT: [
      {
        query: LIFE.CAREERS_QUERY,
        label: 'キャリア',
        url: 'news/types/j-careers',
        type: LIFE.SECTION_ENUM.CAREERS
      },
      {
        query: LIFE.EDITOR_COLUMN_QUERY,
        label: '編集長コラム',
        url: 'news/types/j-editor-column',
        type: LIFE.SECTION_ENUM.EDITOR_COLUMN
      }
    ],
    MORE_LIST: [{ query: LIFE.MAIN, label: 'その他のライフ記事', type: null, url: null }]
  },
  opinion: {
    OPINION_TOP_MODULE: [{ query: OPINION.MAIN, label: 'Top Module', type: null, url: null }],
    OPINION_LEADING_AND_SUPPORT: [
      {
        query: OPINION.OPINION_QUERY,
        label: 'オピニオン',
        url: 'news/types/j-opinion',
        type: OPINION.SECTION_ENUM.OPINION
      },
      {
        query: OPINION.SHASETSU_QUERY,
        label: '社説',
        url: 'news/types/j-shasetsu',
        type: OPINION.SECTION_ENUM.SHASETSU
      },
      {
        query: OPINION.KIKO_QUERY,
        label: '寄稿',
        url: 'news/types/j-kiko',
        type: OPINION.SECTION_ENUM.KIKO
      }
    ],
    OPINION_MORE_LIST: [{ query: OPINION.MAIN, label: 'その他のオピニオン・社説記事', type: null, url: null }]
  },
  technology: {
    SECTION_TOP: [{ query: TECHNOLOGY.MAIN, label: 'Lead Story', type: null, url: null }],
    SECTION_TOP_SIX_STORIES: [{ query: TECHNOLOGY.MAIN, label: 'Top Stories', type: null, url: null }],
    LEADING_AND_SUPPORT: [
      {
        query: TECHNOLOGY.PERSONAL_TECHNOLOGY_QUERY,
        label: 'パーソナルテクノロジー',
        url: 'news/types/j-personal-technology',
        type: TECHNOLOGY.SECTION_ENUM.PERSONAL_TECHNOLOGY
      },
      {
        query: TECHNOLOGY.JOURNAL_REPORTS_QUERY,
        label: 'Journal Reports',
        url: 'news/types/j-journal-reports',
        type: TECHNOLOGY.SECTION_ENUM.JOURNAL_REPORTS
      },
      {
        query: TECHNOLOGY.KEYWORDS_QUERY,
        label: 'Keywords',
        url: 'news/types/j-keywords',
        type: TECHNOLOGY.SECTION_ENUM.KEYWORDS
      }
    ],
    MORE_LIST: [{ query: TECHNOLOGY.MAIN, label: 'その他のテクノロジー記事', type: null, url: null }]
  },
  default: {
    default: [
      {
        query: { ...DEFAULT_QUERY, query: { and: [{ terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } }] } },
        label: 'Custom Query',
        type: null,
        url: null
      }
    ]
  },
  world: {
    SECTION_TOP: [{ query: WORLD.WORLD, label: 'Lead Story', type: null, url: null }],
    SECTION_TOP_SIX_STORIES: [{ query: WORLD.WORLD, label: 'Top Stories', type: null, url: null }],
    LEADING_AND_SUPPORT: [
      {
        query: WORLD.US_QUERY,
        label: '米国',
        url: 'news/types/j-usa',
        type: WORLD.SECTION_ENUM.US
      },
      {
        query: WORLD.CHINA_QUERY,
        label: '中国',
        url: 'news/types/j-china',
        type: WORLD.SECTION_ENUM.CHINA
      },
      {
        query: WORLD.CHINA_NEWSLETTER_QUERY,
        label: '中国洞察',
        url: 'news/types/j-china-newsletter',
        type: WORLD.SECTION_ENUM.CHINA_NEWSLETTER
      },
      {
        query: WORLD.ASIA_AND_OCEANIA_QUERY,
        label: 'アジア・オセアニア',
        url: 'news/types/j-asia-oceania',
        type: WORLD.SECTION_ENUM.ASIA_AND_OCEANIA
      },
      {
        query: WORLD.EUROPE_AND_RUSSIA_QUERY,
        label: '欧州・ロシア',
        url: 'news/types/j-europe-russia',
        type: WORLD.SECTION_ENUM.EUROPE_AND_RUSSIA
      },
      {
        query: WORLD.MIDDLE_EAST_AND_AFRICA_QUERY,
        label: '中東・アフリカ',
        url: 'news/types/j-middle-east-africa',
        type: WORLD.SECTION_ENUM.MIDDLE_EAST_AND_AFRICA
      }
    ],
    MORE_LIST: [{ query: WORLD.WORLD, label: 'その他の国際記事', type: null, url: null }]
  }
};
